import { pipeable } from 'fp-ts';
import * as apply from 'fp-ts/Apply';
import { pipe, tupled } from 'fp-ts/function';
export * from 'fp-ts/Apply';
export const sequence2 = (F) => (a, b) => apply.sequenceT(F)(a, b);
export const sequence3 = (F) => (a, b, c) => apply.sequenceT(F)(a, b, c);
export const sequence4 = (F) => (a, b, c, d) => apply.sequenceT(F)(a, b, c, d);
export const map2 = (F) => (a, b) => (f) => pipe(sequence2(F)(a, b), pipeable.map(F)(tupled(f)));
export const map3 = (F) => (a, b, c) => (f) => pipe(sequence3(F)(a, b, c), pipeable.map(F)(tupled(f)));
//# sourceMappingURL=apply.js.map